import React from 'react';
import { ActionCreateNameIcon } from '../../../../../modules/action-create/components/name-icon';
import { useExalusCreateActionContext } from '../context';
import { useActionCreate } from '../hooks/use-action-create';

const ExalusActionCreateNameIcon: React.FC = () => {
  const { onSubmitNameIcon } = useActionCreate();
  const { actionType, name, icon } = useExalusCreateActionContext();

  return <ActionCreateNameIcon onSubmit={onSubmitNameIcon} name={name} icon={icon} actionType={actionType} />;
};

export default ExalusActionCreateNameIcon;
